<template>
    <div class="pending-approval">
        <base-header class="pb-6">
            <b-row align-v="center" class="py-3">
                <b-col cols="6">
                    <h2 class="listing-title d-inline-block mb-0">VPS Pending Approvals</h2>
                </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6">
            <VPSPendingTable />
        </b-container>
    </div>
</template>
<script>
import VPSPendingTable from '@/views/PendingApprovals/VPS/VpsPendingAppTable'
export default {
    components: {
        VPSPendingTable
    }
}
</script>